"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79223],{

/***/ 79223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tradly_FeaturesTable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constant/AllIcons.js
var AllIcons = __webpack_require__(47520);
;// CONCATENATED MODULE: ./data/Pricing/PricingFeaturesData.js
var feature_groups = [
    {
        title: "Features",
        group_key: "features"
    },
    {
        title: "Web EDITOR",
        group_key: "web_editor"
    },
    {
        title: "Shipping",
        group_key: "shipping"
    },
    {
        title: "Order Management",
        group_key: "order_management"
    },
    {
        title: "Revenue Models",
        group_key: "revenue_models"
    },
    {
        title: "Developers",
        group_key: "developers"
    },
    {
        title: "Communication",
        group_key: "communication"
    },
    {
        title: "Hosting & Security",
        group_key: "hosting_security"
    },
    {
        title: "Payment Methods",
        group_key: "payment_methods"
    },
    {
        title: "Support & Services",
        group_key: "support"
    }, 
];
var pricing_features = {
    visitors: {
        title: "Visitors",
        group_name: "Features",
        group_key: "features",
        item_info: "The number of users browsing your platform"
    },
    internal_users: {
        title: "Internal Users",
        group_name: "Features",
        group_key: "features",
        item_info: "The number of team/staff members using SuperAdmin/workspace"
    },
    external_users: {
        title: "External Users",
        group_name: "Features",
        group_key: "features",
        item_info: "Users signing up in your website & mobile app"
    },
    accounts: {
        title: "Accounts",
        group_name: "Features",
        group_key: "features",
        item_info: "Also called as Seller, Multi Vendors, Campaign Creators, Merchants, Partners, Agency etc."
    },
    listing: {
        title: "Listing",
        group_name: "Features",
        group_key: "features",
        item_info: "Also called as Products, Services, Campaigns, etc."
    },
    stocks: {
        title: "Stocks",
        group_name: "Features",
        group_key: "features",
        item_info: "Stocks limits & Rules"
    },
    custom_fields: {
        title: "Custom Fields/Attributes",
        group_name: "Features",
        group_key: "features",
        item_info: "9 types of custom fields for accounts, listings"
    },
    collection: {
        title: "Collection",
        group_name: "Features",
        group_key: "features",
        item_info: "Collection of listings & accounts"
    },
    geolocation: {
        title: "Geolocation",
        group_name: "Features",
        group_key: "features",
        item_info: "Allow your users to add/browse accounts & listings with map browsing with distance filters"
    },
    social_engagements: {
        title: "Social Engagements",
        group_name: "Features",
        group_key: "features",
        item_info: "Follow, Like, Hashtags browsing"
    },
    quality_systems: {
        title: "Quality Systems",
        group_name: "Features",
        group_key: "features",
        item_info: "Approval, Ratings, Reviews, Report, Block, etc."
    },
    bulk_operations: {
        title: "Bulk Operations",
        group_name: "Features",
        group_key: "features",
        item_info: "Import, Export"
    },
    schedules: {
        title: "Schedules",
        group_name: "Features",
        group_key: "features",
        item_info: "Allow people to book based on calendar"
    },
    simple_variant: {
        title: "Simple Variant",
        group_name: "Features",
        group_key: "features",
        item_info: "Allow your users to create variants under listing. Example: Color, size"
    },
    variant_matrix: {
        title: "Variant Matrix(B2B)",
        group_name: "Features",
        group_key: "features",
        item_info: "Allow your users to choose a combination of variants under listing. Example: iPhone, 128GB, Color"
    },
    pricing_options: {
        title: "Pricing Options",
        group_name: "Features",
        group_key: "features",
        item_info: "Multiple Pricing under a single listing. Ex: Tickets"
    },
    multi_languages_multi_currencies: {
        title: "Multi Languages & Multi Currencies",
        group_name: "Features",
        group_key: "features",
        item_info: "Features on SuperAdmin"
    },
    search_engine_indexing: {
        title: "Search Engine Indexing (SEO)",
        group_name: "Features",
        group_key: "features",
        item_info: "Indexing, Custom scripting across platforms"
    },
    social_login: {
        title: "Social Login",
        group_name: "Features",
        group_key: "features",
        item_info: "Giving your users a Login via Google, Facebook/Meta"
    },
    single_signon: {
        title: "Single Sign On",
        group_name: "Features",
        group_key: "features",
        item_info: "Give your platform access to access via Single Sign On. Useful for Enterprises and Existing websites"
    },
    storage_limit: {
        title: "Storage Limit",
        group_key: "hosting_security",
        item_info: "All time total file size of images, videos, etc."
    },
    layers_advanced_cms: {
        title: "Layers - Advanced CMS",
        group_key: "web_editor",
        item_info: "Blogs, Pages, Dynamic Builder Pages, Custom Types"
    },
    website_templates: {
        title: "Website Templates",
        group_key: "web_editor",
        item_info: "Hosted on Tradly"
    },
    page_history: {
        title: "Page Version History - Days",
        group_name: "Web EDITOR",
        group_key: "web_editor",
        item_info: "History of the edits available to revert back"
    },
    integrations: {
        title: "Web Integrations",
        group_name: "Web EDITOR",
        group_key: "web_editor",
        item_info: "3rd Party Integrations you can add to your website without code."
    },
    basic_rules: {
        title: "Basic Rules",
        group_name: "Web EDITOR",
        group_key: "web_editor",
        item_info: "Visibility Rules on block level for logged in, logout. Currently available on few blocks."
    },
    css_level_edit: {
        title: "CSS Level Edit",
        group_name: "Web EDITOR",
        group_key: "web_editor",
        item_info: "Spacing, Size, Position, Background, etc."
    },
    advanced: {
        title: "Advanced Workflow",
        group_name: "Web EDITOR",
        group_key: "web_editor",
        item_info: "Mobile Separate CSS, Draft/Live Mode, Copy/Paste Style"
    },
    custom_code_injection: {
        title: "Custom Code Injection",
        group_name: "Web EDITOR",
        group_key: "web_editor",
        item_info: "Add custom code"
    },
    advanced_rules: {
        title: "Advanced Rules",
        group_name: "Web EDITOR",
        group_key: "web_editor",
        item_info: "Visibility Rules for paid subscribed member (applicable to subscription business model)"
    },
    shipping_logics: {
        title: "Shipping Logics",
        group_name: "Shipping",
        group_key: "shipping",
        item_info: "Fee calculation, Insert Tracking Number, Coming Soon (Country & Pincode level fee)"
    },
    custom_logics: {
        title: "Custom Logics",
        group_name: "Shipping",
        group_key: "shipping",
        item_info: "Add or remove delivery, Pickup & Storage Hub (Warehouse, Pickup points), Find Store"
    },
    fulfillment_by_platform: {
        title: "Fulfillment by Platform",
        group_name: "Shipping",
        group_key: "shipping",
        item_info: "Platform able to manage shipping of their sellers."
    },
    cart_based_ordering: {
        title: "Cart based Ordering",
        group_name: "Order Management",
        group_key: "order_management",
        item_info: "For e-commerce product shopping"
    },
    direct_booking_order: {
        title: "Direct Booking/order",
        group_name: "Order Management",
        group_key: "order_management",
        item_info: "For Event Booking, SaaS Appstore, etc"
    },
    order_status_workflow: {
        title: "Order status workflow",
        group_name: "Order Management",
        group_key: "order_management"
    },
    order_status_flow_persistent_messages: {
        title: "Order Status flow persistent messages",
        group_name: "Order Management",
        group_key: "order_management"
    },
    transaction_split: {
        title: "Transaction Split",
        group_name: "Order Management",
        group_key: "order_management",
        item_info: "Platform Commission, Shipping, Payout, PG Fee"
    },
    other_order_logics: {
        title: "Other Order Logics",
        group_name: "Order Management",
        group_key: "order_management",
        item_info: "Min quantity rule, min and max amount per order, saved address"
    },
    negotiation_offer_price: {
        title: "Negotiation / Offer price",
        group_name: "Order Management",
        group_key: "order_management",
        item_info: "Plus Expiry time for negotiated price"
    },
    special_fees: {
        title: "Special Fees (Price Markup)",
        group_name: "Revenue Models",
        group_key: "revenue_models"
    },
    commission_deduction: {
        title: "Commission deduction",
        group_name: "Revenue Models",
        group_key: "revenue_models"
    },
    gated_subscription_on_platform: {
        title: "Gated Subscription on Platform(*1)",
        group_name: "Revenue Models",
        group_key: "revenue_models"
    },
    subscription_on_listing: {
        title: "Subscription on Listing (*1)",
        group_name: "Revenue Models",
        group_key: "revenue_models"
    },
    api_reference_sdk_support: {
        title: "API Reference & SDK Support",
        group_name: "Developers",
        group_key: "developers",
        item_info: "REST API, JS SDK"
    },
    api_rate_limit: {
        title: "API Rate Limit",
        group_name: "Developers",
        group_key: "developers",
        item_info: "Number of request per minute"
    },
    open_source_apps_support: {
        title: "Open Source Apps Support",
        group_name: "Developers",
        group_key: "developers",
        item_info: "CRA, NextJS, React Native, Flutter"
    },
    webhooks: {
        title: "Webhooks",
        group_name: "Developers",
        group_key: "developers",
        item_info: "Ready Trigger events to 3rd party tools like Zapier, Make."
    },
    headless_api_access: {
        title: "Headless API access",
        group_name: "Developers",
        group_key: "developers",
        item_info: "Partner developers has separate access"
    },
    email_from_address: {
        title: 'Email "From Address"',
        group_name: "Communication",
        group_key: "communication",
        item_info: "System emails (OTP emails, order emails, etc)"
    },
    customize_email_templates: {
        title: "Customize Email Templates",
        group_name: "Communication",
        group_key: "communication",
        item_info: "System emails (Welcome, OTP emails, order emails, etc)"
    },
    in_app_chat: {
        title: "In-App Chat",
        group_name: "Communication",
        group_key: "communication",
        item_info: "Between your users in mobile app"
    },
    web_app_deployment: {
        title: "Web App Hosting",
        group_name: "Hosting & Security",
        group_key: "hosting_security",
        item_info: "Hosting the web apps under Tradly Hosting"
    },
    ssl: {
        title: "SSL",
        group_name: "Hosting & Security",
        group_key: "hosting_security",
        item_info: "SSL Cert"
    },
    sites: {
        title: "Number of Sites under workspace",
        group_name: "Hosting & Security",
        group_key: "hosting_security",
        item_info: "Number of sites under single project/tenant"
    },
    custom_domain: {
        title: "Custom Domain",
        group_name: "Hosting & Security",
        group_key: "hosting_security",
        item_info: "Web App"
    },
    rbac: {
        title: "RBAC",
        group_name: "Hosting & Security",
        group_key: "hosting_security",
        item_info: "Roll based access control across every features"
    },
    managed_support: {
        title: "Managed Support (Android, iOS)",
        group_name: "Hosting & Security",
        group_key: "hosting_security",
        item_info: "If you have purchased mobile app code"
    },
    stripe: {
        title: "Stripe",
        group_name: "Payment Methods",
        group_key: "payment_methods",
        item_info: "50+ Countries, Payemnnts, Connect for marketplace (Standard & Express)"
    },
    paydunya: {
        title: "PayDunya (*3)",
        group_name: "Payment Methods",
        group_key: "payment_methods",
        item_info: "Senegal, Ivory Coast and the Republic of Benin"
    },
    pawapay: {
        title: "Pawapay(19)",
        group_name: "Payment Methods",
        group_key: "payment_methods",
        item_info: "Africa"
    },
    others: {
        title: "Others",
        group_name: "Payment Methods",
        group_key: "payment_methods",
        item_info: "Razorpay(IN), Billpay(MY), OnlinePaymentPlatform(EU)"
    },
    cash_based: {
        title: "Cash Based",
        group_name: "Payment Methods",
        group_key: "payment_methods",
        item_info: "Cash on delivery/pickup, etc"
    },
    payu: {
        title: "PayU (*3)",
        group_name: "Payment Methods",
        group_key: "payment_methods",
        item_info: "Colombia, Argentina, Brazil, Mexico, Chile, Peru and Panama"
    },
    mangopay: {
        title: "MangoPay",
        group_name: "Payment Methods",
        group_key: "payment_methods",
        item_info: "31 European Economic Area (EEA) + UK"
    },
    myfatoorah: {
        title: "Myfatoorah",
        group_name: "Payment Methods",
        group_key: "payment_methods",
        item_info: "KW, SA, BH, UAE, QA, EG, Oman, JO"
    },
    additional_payments: {
        title: "Additional Payments",
        group_name: "Payment Methods",
        group_key: "payment_methods",
        item_info: "With implementation charges - on-demand implementation"
    },
    self_help: {
        title: "Video Tutorials & Self Help",
        group_name: "Support",
        group_key: "support",
        item_info: "Documentation access. Video tutorials in different channels"
    },
    community_forum: {
        title: "Community Forum",
        group_name: "Support",
        group_key: "support",
        item_info: "Discussing with community and helping each other"
    },
    support_desk: {
        title: "Support Portal",
        group_name: "Support",
        group_key: "support",
        item_info: "Submit tickets via Support Portal with Standard SLA"
    },
    live_chat: {
        title: "Live Chat",
        group_name: "Support",
        group_key: "support",
        item_info: "Live Chat with Standard SLA"
    },
    sales_call: {
        title: "Sales & Consulting - Google Meet Call",
        group_name: "Support",
        group_key: "support",
        item_info: "Scheduled Google Meet call to understand custom development needs"
    },
    custom_development_services: {
        title: "Custom Development Services",
        group_name: "Support",
        group_key: "support",
        item_info: "Additional custom integration of 3rd Party Services"
    },
    account_manager: {
        title: "Customer Success Manager",
        group_name: "Support",
        group_key: "support",
        item_info: "Single point of contact for all your communication"
    },
    priority_desk: {
        title: "Priority Case Management",
        group_name: "Support",
        group_key: "support",
        item_info: "Faster priority support for your team on critical things"
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./data/Pricing/PricingFetauresPackageRelationData.js

var _obj;
var pricing_features_package_relations = (_obj = {
    visitors: {
        community: {
            type: "text",
            value: "Unlimited"
        },
        starter: {
            type: "text",
            value: "Unlimited"
        },
        growth: {
            type: "text",
            value: "Unlimited"
        },
        scale: {
            type: "text",
            value: "Unlimited"
        }
    },
    internal_users: {
        community: {
            type: "text",
            value: "Unlimited"
        },
        starter: {
            type: "text",
            value: "Unlimited"
        },
        growth: {
            type: "text",
            value: "Unlimited"
        },
        scale: {
            type: "text",
            value: "Unlimited"
        }
    },
    external_users: {
        community: {
            type: "number",
            value: 2500
        },
        starter: {
            type: "number",
            value: 15000
        },
        growth: {
            type: "number",
            value: 150000
        },
        scale: {
            type: "number",
            value: 300000
        }
    },
    accounts: {
        community: {
            type: "number",
            value: 1500
        },
        starter: {
            type: "number",
            value: 3000
        },
        growth: {
            type: "number",
            value: 30000
        },
        scale: {
            type: "number",
            value: 100000
        }
    },
    listing: {
        community: {
            type: "number",
            value: 1500
        },
        starter: {
            type: "number",
            value: 15000
        },
        growth: {
            type: "number",
            value: 100000
        },
        scale: {
            type: "number",
            value: 300000
        }
    },
    stocks: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    schedules: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    simple_variant: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    variant_matrix: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    pricing_options: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    social_engagements: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    social_login: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    single_signon: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: false
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    quality_systems: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    multi_languages_multi_currencies: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    search_engine_indexing: {
        community: {
            type: "text",
            value: "Basic"
        },
        starter: {
            type: "text",
            value: "Advanced"
        },
        growth: {
            type: "text",
            value: "Advanced"
        },
        scale: {
            type: "text",
            value: "Advanced"
        }
    },
    custom_fields: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    collection: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    geolocation: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    bulk_operations: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    storage_limit: {
        community: {
            type: "text",
            value: "500MB"
        },
        starter: {
            type: "text",
            value: "50GB"
        },
        growth: {
            type: "text",
            value: "1TB"
        },
        scale: {
            type: "text",
            value: "5TB"
        }
    },
    layers_advanced_cms: {
        community: {
            type: "text",
            value: "Yes"
        },
        starter: {
            type: "text",
            value: "Yes"
        },
        growth: {
            type: "text",
            value: "Yes"
        },
        scale: {
            type: "text",
            value: "Yes"
        }
    },
    website_templates: {
        community: {
            type: "text",
            value: "20+ Free"
        },
        starter: {
            type: "text",
            value: "30+"
        },
        growth: {
            type: "text",
            value: "30+"
        },
        scale: {
            type: "text",
            value: "30+"
        }
    },
    page_history: {
        community: {
            type: "text",
            value: "3 Days"
        },
        starter: {
            type: "text",
            value: "30 Days"
        },
        growth: {
            type: "text",
            value: "90 Days"
        },
        scale: {
            type: "text",
            value: "1 Year"
        }
    },
    integrations: {
        community: {
            type: "text",
            value: "20+ Free"
        },
        starter: {
            type: "text",
            value: "25+"
        },
        growth: {
            type: "text",
            value: "25+"
        },
        scale: {
            type: "text",
            value: "25+"
        }
    },
    css_level_edit: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    custom_code_injection: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    advanced: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    basic_rules: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    advanced_rules: {
        community: {
            type: "text",
            value: "-"
        },
        starter: {
            type: "text",
            value: "-"
        },
        growth: {
            type: "text",
            value: "Coming Soon"
        },
        scale: {
            type: "text",
            value: "Coming Soon"
        }
    },
    shipping_logics: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    custom_logics: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    fulfillment_by_platform: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    cart_based_ordering: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    direct_booking_order: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    negotiation_offer_price: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    order_status_workflow: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    order_status_flow_persistent_messages: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    transaction_split: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    other_order_logics: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    gated_subscription_on_platform: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    special_fees: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    commission_deduction: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    subscription_on_listing: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: false
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    webhooks: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    headless_api_access: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    api_rate_limit: {
        community: {
            type: "text",
            value: "120 RPM"
        },
        starter: {
            type: "text",
            value: "120 RPM"
        },
        growth: {
            type: "text",
            value: "120 RPM"
        },
        scale: {
            type: "text",
            value: "Custom"
        }
    },
    open_source_apps_support: {
        community: {
            type: "text",
            value: "-"
        },
        starter: {
            type: "text",
            value: "-"
        },
        growth: {
            type: "text",
            value: "Community forum"
        },
        scale: {
            type: "text",
            value: "Community forum"
        }
    },
    api_reference_sdk_support: {
        community: {
            type: "text",
            value: "Community forum"
        },
        starter: {
            type: "text",
            value: "+Email/Tickets"
        },
        growth: {
            type: "text",
            value: "Same"
        },
        scale: {
            type: "text",
            value: "Same"
        }
    },
    email_from_address: {
        community: {
            type: "text",
            value: "Tradly email"
        },
        starter: {
            type: "text",
            value: "Tradly email"
        },
        growth: {
            type: "text",
            value: "Your Domain"
        },
        scale: {
            type: "text",
            value: "Your Domain"
        }
    },
    customize_email_templates: {
        community: {
            type: "text",
            value: "-"
        },
        starter: {
            type: "text",
            value: "Yes"
        },
        growth: {
            type: "text",
            value: "Yes"
        },
        scale: {
            type: "text",
            value: "Yes"
        }
    },
    in_app_chat: {
        community: {
            type: "text",
            value: "-"
        },
        starter: {
            type: "text",
            value: "-"
        },
        growth: {
            type: "text",
            value: "-"
        },
        scale: {
            type: "text",
            value: "Yes"
        }
    },
    web_app_deployment: {
        community: {
            type: "text",
            value: "Yes"
        },
        starter: {
            type: "text",
            value: "Yes"
        },
        growth: {
            type: "text",
            value: "Yes"
        },
        scale: {
            type: "text",
            value: "Yes"
        }
    },
    ssl: {
        community: {
            type: "text",
            value: "Yes"
        },
        starter: {
            type: "text",
            value: "Yes"
        },
        growth: {
            type: "text",
            value: "Yes"
        },
        scale: {
            type: "text",
            value: "Yes"
        }
    },
    rbac: {
        community: {
            type: "text",
            value: "-"
        },
        starter: {
            type: "text",
            value: "-"
        },
        growth: {
            type: "text",
            value: "Yes"
        },
        scale: {
            type: "text",
            value: "Yes"
        }
    },
    sites: {
        community: {
            type: "text",
            value: "2"
        },
        starter: {
            type: "text",
            value: "3"
        },
        growth: {
            type: "text",
            value: "5"
        },
        scale: {
            type: "text",
            value: "20"
        }
    },
    custom_domain: {
        community: {
            type: "text",
            value: "Tradly.co free subdomain + Add your own domain"
        },
        starter: {
            type: "text",
            value: "Same"
        },
        growth: {
            type: "text",
            value: "Same"
        },
        scale: {
            type: "text",
            value: "Same"
        }
    },
    managed_support: {
        community: {
            type: "text",
            value: "-"
        },
        starter: {
            type: "text",
            value: "-"
        },
        growth: {
            type: "text",
            value: "-"
        },
        scale: {
            type: "text",
            value: "Yes"
        }
    },
    stripe: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    mangopay: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    myfatoorah: {
        community: {
            type: "boolean",
            value: false
        },
        starter: {
            type: "boolean",
            value: false
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    },
    pawapay: {
        community: {
            type: "boolean",
            value: true
        },
        starter: {
            type: "boolean",
            value: true
        },
        growth: {
            type: "boolean",
            value: true
        },
        scale: {
            type: "boolean",
            value: true
        }
    }
}, (0,_define_property/* default */.Z)(_obj, "pawapay", {
    community: {
        type: "boolean",
        value: true
    },
    starter: {
        type: "boolean",
        value: true
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "payu", {
    community: {
        type: "boolean",
        value: false
    },
    starter: {
        type: "boolean",
        value: true
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "others", {
    community: {
        type: "boolean",
        value: true
    },
    starter: {
        type: "boolean",
        value: true
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "cash_based", {
    community: {
        type: "boolean",
        value: true
    },
    starter: {
        type: "boolean",
        value: true
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "additional_payments", {
    community: {
        type: "boolean",
        value: false
    },
    starter: {
        type: "boolean",
        value: false
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "self_help", {
    community: {
        type: "boolean",
        value: true
    },
    starter: {
        type: "boolean",
        value: true
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "email_support", {
    community: {
        type: "boolean",
        value: true
    },
    starter: {
        type: "boolean",
        value: true
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "support_desk", {
    community: {
        type: "boolean",
        value: false
    },
    starter: {
        type: "boolean",
        value: true
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "community_forum", {
    community: {
        type: "boolean",
        value: true
    },
    starter: {
        type: "boolean",
        value: true
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "live_chat", {
    community: {
        type: "boolean",
        value: false
    },
    starter: {
        type: "boolean",
        value: false
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "sales_call", {
    community: {
        type: "text",
        value: "-"
    },
    starter: {
        type: "text",
        value: "One Free 1hr Call. Further charged/Hour & analysis charges"
    },
    growth: {
        type: "text",
        value: "same"
    },
    scale: {
        type: "text",
        value: "same"
    }
}), (0,_define_property/* default */.Z)(_obj, "account_manager", {
    community: {
        type: "boolean",
        value: false
    },
    starter: {
        type: "boolean",
        value: false
    },
    growth: {
        type: "boolean",
        value: false
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "custom_development_services", {
    community: {
        type: "boolean",
        value: false
    },
    starter: {
        type: "boolean",
        value: false
    },
    growth: {
        type: "boolean",
        value: true
    },
    scale: {
        type: "boolean",
        value: true
    }
}), (0,_define_property/* default */.Z)(_obj, "priority_desk", {
    community: {
        type: "boolean",
        value: false
    },
    starter: {
        type: "boolean",
        value: false
    },
    growth: {
        type: "boolean",
        value: false
    },
    scale: {
        type: "boolean",
        value: true
    }
}), _obj);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Tradly/FeaturesTable.js








function FeaturesTable() {
    var router = (0,next_router.useRouter)();
    var features_list_with_group = feature_groups === null || feature_groups === void 0 ? void 0 : feature_groups.map(function(feature_group) {
        var ref;
        return {
            group_name: feature_group === null || feature_group === void 0 ? void 0 : feature_group.title,
            key_name: feature_group.group_key,
            list_of_features: (ref = Object.keys(pricing_features).filter(function(pf_key) {
                var ref;
                return ((ref = pricing_features[pf_key]) === null || ref === void 0 ? void 0 : ref.group_key) === (feature_group === null || feature_group === void 0 ? void 0 : feature_group.group_key);
            })) === null || ref === void 0 ? void 0 : ref.map(function(key_name) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pricing_features[key_name]), {
                    key_name: key_name,
                    package_relations: pricing_features_package_relations[key_name]
                });
            })
        };
    });
    (0,react.useEffect)(function() {
        // Check if there is a hash in the URL
        if (router.asPath.includes("#")) {
            var elementId = router.asPath.split("#")[1];
            var element = document.getElementById(elementId);
            if (element) {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " bg-white z-50 sticky top-0 ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " max-w-6xl mx-auto px-4 sm:px-6 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pb-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            id: "features",
                            className: "h2",
                            children: "Package Comparison"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                            className: "table-fixed w-full border-b border-gray-200",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                    className: " sticky top-0 bg-white z-50 shadow-md",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        className: " text-xs md:text-lg border-t border-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: " text-left pr-2 py-4 w-[25%] md:w-[35%]",
                                                children: "Breakdown of features"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: " text-center md:px-2 py-4",
                                                children: "Community"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: " text-center md:px-2 py-4",
                                                children: "Starter"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: " text-center md:px-2 py-4",
                                                children: "Growth"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: " text-center md:pl-2 py-4",
                                                children: "Scale"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                    className: "overflow-x-scroll ",
                                    children: features_list_with_group === null || features_list_with_group === void 0 ? void 0 : features_list_with_group.map(function(item, index) {
                                        var ref;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                index !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    id: item === null || item === void 0 ? void 0 : item.key_name,
                                                    className: " dh3 py-6 whitespace-nowrap",
                                                    children: item === null || item === void 0 ? void 0 : item.group_name
                                                }),
                                                item === null || item === void 0 ? void 0 : (ref = item.list_of_features) === null || ref === void 0 ? void 0 : ref.map(function(f_item) {
                                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
                                                    var package_data = f_item === null || f_item === void 0 ? void 0 : f_item.package_relations;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        className: "border-t border-gray-200 grid-cols-4 tooltip",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                className: " text-xs md:text-base pr-2 py-4 flex items-center justify-between md:justify-start gap-1 ",
                                                                children: [
                                                                    f_item === null || f_item === void 0 ? void 0 : f_item.title,
                                                                    (f_item === null || f_item === void 0 ? void 0 : f_item.item_info) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: " group",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: " cursor-pointer",
                                                                                children: AllIcons.info_icon
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: " hidden absolute group-hover:block bg-gray-600 text-gray-50 text-sm mt-2 text-start p-2 z-20 rounded-md max-w-xs",
                                                                                children: f_item === null || f_item === void 0 ? void 0 : f_item.item_info
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: " text-[8px] md:text-sm md:px-2 py-4 text-center md:font-medium",
                                                                children: (package_data === null || package_data === void 0 ? void 0 : (ref = package_data.community) === null || ref === void 0 ? void 0 : ref.type) === "text" ? package_data === null || package_data === void 0 ? void 0 : (ref1 = package_data.community) === null || ref1 === void 0 ? void 0 : ref1.value : (package_data === null || package_data === void 0 ? void 0 : (ref2 = package_data.community) === null || ref2 === void 0 ? void 0 : ref2.type) === "number" ? package_data === null || package_data === void 0 ? void 0 : (ref3 = package_data.community) === null || ref3 === void 0 ? void 0 : ref3.value.toLocaleString() : (package_data === null || package_data === void 0 ? void 0 : (ref4 = package_data.community) === null || ref4 === void 0 ? void 0 : ref4.value) ? AllIcons.check_icon : AllIcons.x_icon
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: " text-[8px] md:text-sm md:px-2 py-4 text-center md:font-medium",
                                                                children: (package_data === null || package_data === void 0 ? void 0 : (ref5 = package_data.starter) === null || ref5 === void 0 ? void 0 : ref5.type) === "text" ? package_data === null || package_data === void 0 ? void 0 : (ref6 = package_data.starter) === null || ref6 === void 0 ? void 0 : ref6.value : (package_data === null || package_data === void 0 ? void 0 : (ref7 = package_data.starter) === null || ref7 === void 0 ? void 0 : ref7.type) === "number" ? package_data === null || package_data === void 0 ? void 0 : (ref8 = package_data.starter) === null || ref8 === void 0 ? void 0 : ref8.value.toLocaleString() : (package_data === null || package_data === void 0 ? void 0 : (ref9 = package_data.starter) === null || ref9 === void 0 ? void 0 : ref9.value) ? AllIcons.check_icon : AllIcons.x_icon
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                className: " text-[8px] md:text-sm md:px-2 py-4 text-center md:font-medium",
                                                                children: [
                                                                    " ",
                                                                    (package_data === null || package_data === void 0 ? void 0 : (ref10 = package_data.growth) === null || ref10 === void 0 ? void 0 : ref10.type) === "text" ? package_data === null || package_data === void 0 ? void 0 : (ref11 = package_data.growth) === null || ref11 === void 0 ? void 0 : ref11.value : (package_data === null || package_data === void 0 ? void 0 : (ref12 = package_data.growth) === null || ref12 === void 0 ? void 0 : ref12.type) === "number" ? package_data === null || package_data === void 0 ? void 0 : (ref13 = package_data.growth) === null || ref13 === void 0 ? void 0 : ref13.value.toLocaleString() : (package_data === null || package_data === void 0 ? void 0 : (ref14 = package_data.growth) === null || ref14 === void 0 ? void 0 : ref14.value) ? AllIcons.check_icon : AllIcons.x_icon
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                className: " text-[8px] md:text-sm md:px-2 py-4 text-center md:font-medium",
                                                                children: [
                                                                    " ",
                                                                    (package_data === null || package_data === void 0 ? void 0 : (ref15 = package_data.scale) === null || ref15 === void 0 ? void 0 : ref15.type) === "text" ? package_data === null || package_data === void 0 ? void 0 : (ref16 = package_data.scale) === null || ref16 === void 0 ? void 0 : ref16.value : (package_data === null || package_data === void 0 ? void 0 : (ref17 = package_data.scale) === null || ref17 === void 0 ? void 0 : ref17.type) === "number" ? package_data === null || package_data === void 0 ? void 0 : (ref18 = package_data.scale) === null || ref18 === void 0 ? void 0 : ref18.value.toLocaleString() : (package_data === null || package_data === void 0 ? void 0 : (ref19 = package_data.scale) === null || ref19 === void 0 ? void 0 : ref19.value) ? AllIcons.check_icon : AllIcons.x_icon
                                                                ]
                                                            })
                                                        ]
                                                    });
                                                })
                                            ]
                                        });
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "*1 – Example of Platform Subscription – A platform like Depop requires it’s seller to pay monthly subscription if they want to sell more than 5 item-",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "*2 – Example of Product subscription – A customer subscribing to a monthly subscription of meal box",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "*3 – When a payment gateway provides only payments, then the all the transacted money will go directly to your bank account. You need to manage payouts manually to your sellers/service providers in marketplace",
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var Tradly_FeaturesTable = (FeaturesTable);


/***/ })

}]);